import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { Network } from '@root/entities/network/model'
import { PlatformUtil } from '@root/shared'

import { ProviderIcon } from './provider-icon'
import { ProviderTooltipContent } from './provider-tooltip-content'
import { PROVIDER_BADGE_LABEL_MAP } from './provider-ui-util'

import type { PairModel } from '@root/entities/pair/atoms/reatom-pair'
import type { ClassNameProps } from '@root/shared/react'

type ProviderBadgeProps = {
  pair: PairModel
} & ClassNameProps

export const ProviderBadge: React.FC<ProviderBadgeProps> = ({
  pair,
  className,
}) => {
  const handleExploreOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()

    const explorerLink = Network.makeExplorerContractLink(
      pair.network,
      pair.address,
    )

    PlatformUtil.openLink(explorerLink)
  }

  return (
    <Tooltip
      content={
        <ProviderTooltipContent
          provider={pair.provider}
          network={pair.network}
        />
      }
    >
      <Root className={className} onClick={handleExploreOpen}>
        <ProviderIcon size={14} provider={pair.provider} />
        <Label>{PROVIDER_BADGE_LABEL_MAP[pair.provider.id]}</Label>
      </Root>
    </Tooltip>
  )
}

const Root = styled.div`
  pointer-events: auto;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;

  cursor: pointer;
`

const Label = styled.div`
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
